<template>
  <div id="app">
    <div style="max-width: 400px; margin: auto; padding: 64px 16px;">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {}
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //font-size: 16px;
  line-height: 1.4;
  color: #1d000f;
}

a {
  color: blue;

  text-decoration: none;

  &:hover, &:active, &:focus {
    text-decoration: underline;
  }

  &:hover, &:hover:visited {
    color: #536aff;
  }

  &:active, &:active:visited {
    color: #92a1ff;
  }

  &:visited {
    color: blue;
  }
}

ul {
  /*list-style-type: none;*/
  padding: 0 20px;
}

li {
  /*display: inline-block;*/
  /*margin: 0 10px;*/
}

</style>
